import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg {...props} viewBox="0 0 63 43">
      <path d="M45.1866 36H11.0477C8.0456 36 1.84664 34.1854 1.06771 26.9268C0.348549 20.2251 5.52219 17.1738 8.81082 16.2878C9.26177 16.1664 9.59609 15.7784 9.65046 15.3146C10.015 12.2049 11.6658 9.89398 12.5082 9.08069C15.1043 6.47593 19.2071 7.12208 21.6723 8.02929C22.2434 8.23947 22.8982 7.95865 23.146 7.40284C25.6384 1.81395 31.795 0.8024 34.7198 1.02891C42.1474 1.4734 44.6668 8.01456 45.1164 11.9587C45.175 12.4724 45.5838 12.8842 46.0981 12.9369C54.371 13.7862 56.816 19.865 56.9923 22.9009C57.2844 32.8514 49.2436 35.7797 45.1866 36Z" />
      <path d="M50.5 19C44.1487 19 39 24.1487 39 30.5C39 36.8513 44.1487 42 50.5 42C56.8513 42 62 36.8513 62 30.5C62 24.1487 56.8513 19 50.5 19Z M54.4375 28.8655L50.6505 25.2495 M46.5619 28.8655L50.5337 25.2495 M50.5 25.9062L50.5 35.75" />
    </svg>
  )
}

export default Icon
